import {Box, InputAdornment, TextField} from '@mui/material';
import {ErrorMessage} from 'formik';
import makeStyles from '@mui/styles/makeStyles';
import styles from 'assets/jss/FieldsStyle/InputsStyle';
const useStyles = makeStyles(styles);

const FormikField = ({
  name,
  values,
  errors,
  submitCount,
  setFieldValue,
  placeholder,
  icon,
  type,
  disabled,
  fromSignup = false,
}) => {
  const classes = useStyles();
  //  ****** conditionally style ********
  const isAddressField = name === 'address';
  const addressFieldLength = fromSignup
    ? 0
    : values?.address?.length !== 0 && values?.address;
  // const fieldHasLength = values[name]?.length !== 0;
  // textArea style
  const textArea = {
    '& textArea': {
      textAlign: 'center',
      marginTop: addressFieldLength && '20px',
    },
  };
  // adornment style
  const adornmentStyle = {
    display: 'flex',
    alignItems: 'center',
    mr: isAddressField ? '4px' : '15px',
    position: isAddressField && addressFieldLength && 'absolute',
    right: isAddressField && '14px',
    top: isAddressField && '22px',
  };
  // custom textfield style for address
  const textAreaStyle = {
    '& input': {
      direction:
        name === 'name'
          ? 'rtl'
          : name === 'phoneNumber'
          ? 'ltr'
          : name === 'address'
          ? 'rtl !important'
          : '',
    },
    '& .MuiInputBase-root': {
      display: isAddressField && 'flex',
      flexDirection: isAddressField && addressFieldLength && 'column',
      height: isAddressField && !addressFieldLength && '70px',
    },
  };
  // ******** end of conditionally style *************

  return (
    <Box sx={{mb: '14px'}}>
      <TextField
        fullWidth
        type={type}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        InputProps={{
          className: classes.inputBox,
          sx: textArea,
          startAdornment: (
            <InputAdornment position='start' sx={adornmentStyle}>
              <img src={icon} alt='' />
            </InputAdornment>
          ),
        }}
        className={classes.textField}
        sx={textAreaStyle}
        value={fromSignup ? null : values[name]}
        onChange={(event) => setFieldValue(name, event.target?.value)}
        multiline={isAddressField}
        inputProps={{maxLength: name === 'name' ? 41 : 251}}
        error={!!submitCount && errors[name]}
        helperText={
          !!submitCount && (
            <ErrorMessage
              name={name}
              render={(msg) => <div className={classes.errMessage}>{msg}</div>}
            />
          )
        }
      />
    </Box>
  );
};

export default FormikField;
